<template>
  <div class="modal fade bs-example-modal-lg sync-in-progress" id="sync-in-progress-modal" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-simple modal-center">
        <div class="modal-content">
          <div class="modal-body  modal-padding">
            <div class="row">
              <div class="col-sm-12 text-align-center form-content">
                <div class="row">
                  <div class="col-md-12">
                    <img src="/static/assets/images/SuperHote_icons/verify-email--red.png" width="150" alt="mail" class="img-responsive" >
                    <h5 class="text-red">
                      <strong>
                        {{ $t('home.verify_modal_text_1') }}
                      </strong>
                    </h5>
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-md-12">
                    <p>{{ $t('home.sync_data_of_platform') }}</p>
                  </div>
                  <div class="text-center mt-50">
                    <button class="btn waves-effect waves-classic" type="button" @click.prevent="closeModal('#sync-in-progress-modal')">{{ $t("button.ok") }}</button>
                  </div>
                </div>
                <br><br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import mixin from "../../mixins/mixin";

export default {
  name: "modal",
  mixins: [mixin]
}
</script>



// WEBPACK FOOTER //
// modal.vue?b31595b8